import React, { FunctionComponent } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import ErrorDisplay from "./ErrorDisplay";

interface ErrorSummaryProps {
  names: string[];
}

const ErrorSummary: FunctionComponent<ErrorSummaryProps> = (props) => {
  const errors = useSelector(
    (state: RootState) => state.global.errors.messages
  );
  const trackedErrors =
    [...errors].filter(
      (error) =>
        [...props.names].filter((name) => error.name.indexOf(name) === 0)
          .length > 0
    ) || [];

  return <ErrorDisplay errors={trackedErrors} />;
};

export default React.memo(
  ErrorSummary,
  (prevProps, nextProps) => prevProps.names.length === nextProps.names.length
);
